module.exports = __webpack_public_path__ + "static/media/serviziErogatiEnte.5df33a36.png";